// extracted by mini-css-extract-plugin
export default {"form":"Form_form__e1yzW","form-heading":"Form_form-heading__Ff+hf","form-input":"Form_form-input__5EMq1","form-button":"Form_form-button__ZFcCC"};